import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_HYDRO_TRACKING } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CampaignTracking from '../../../campaign/components/campaignTracking/CampaignTracking'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { useParams } from 'react-router'


const HydrometryCampaignTrackingApp = ({}) => {
    const {
        hydrometricStations,
    } = useSelector(store => ({
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
    }), shallowEqual)

    const dispatch = useDispatch()
    const { id } = useParams()


    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_HYDRO_TRACKING)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.fetchHydrometryCampaignEvent(id))
    }, [dispatch, id])

    return (
        <CampaignTracking
            stations={hydrometricStations}
            stationType='hydrometry'
        />
    )
}

export default HydrometryCampaignTrackingApp